@if (!!error) {
  <app-error-strip
    [popup]="true"
    i18n="
      XMSG|An error that is displayed when failed to retrieve
      organizations@@organizations.errors.retrievalFailed"
    [errorText]="'Could not fetch existing resources from the server; please try again later.'"
    [errorMsg]="error.message"
  ></app-error-strip>
}
<app-panel-header
  (doSearch)="doSearch($event)"
  [resourceType]="resourceType"
  [showCreateMenu]="true"
  [showCreateYAML]="true"
  [showCreateServiceInstance]="true"
  [systemResourcesByGroup]="systemResourcesByGroup"
  [loadingFinished]="!loading"
  [advancedSearchOpen]="advancedSearchOpen"
  [advancedSearchReady]="advancedSearchReady"
  [resultCount]="resourceContent?.items?.length || 0"
  [filterViewName]="currentFilterViewName"
  [organizationPath]="getOrganizationPath()"
  [savedFilterViewsDisabled]="isFclOpen"
  (viewSelected)="onSavedViewSelected($event)"
  (advancedSearchToggled)="onAdvancedSearchToggled($event)"
  (createGenericResource)="onCreateGenericResource()"
  (createServiceInstance)="onCreateServiceInstance($event)"
  [glyph]="resourceType | resourceGlyph"
  text="{{ resourceType }}: {{ currentResourceDisplayName }}"
  [body]="headerBody"
></app-panel-header>
<ng-template #headerBody>
  @if (resourceContent.containerIsMoving && !advancedSearchOpen) {
    <app-status
      [status]="ResourceState.IN_PROCESS"
      (click)="openOperationJson()"
      [withConditionsTable]="false"
      [customTooltip]="RESOURCE_MOVING_IN_PROCESS"
    ></app-status>
  }
  <fd-toolbar-spacer></fd-toolbar-spacer>
  @if (!advancedSearchOpen) {
    <button
      id="refresh-button"
      fd-button
      fdType="transparent"
      (click)="resourceContent.loadContent()"
      [disabled]="resourceContent.loading"
    >
      <app-icon icon="rotate-right" size="lg" [fixedWidth]="true"></app-icon>
    </button>
  }
  @if (!advancedSearchOpen) {
    <app-show-parent-data-btn
      (toggleParentData)="this.resourceContent.toggleFcl($event)"
      [isFclOpen]="isFclOpen"
      [parentPath]="parentPath"
      [currentOrg]="currentOrg"
      [currentResource]="currentResource"
      [resourceType]="resourceType"
      [selectedRow]="resourceContent.selectedRow"
    ></app-show-parent-data-btn>
  }
  @if (!advancedSearchOpen) {
    <app-reset-filter-btn
      [disableClearFilter]="!resourceContent?.dataTable?.hasFilter"
      (resetFilter)="reset()"
    ></app-reset-filter-btn>
  }

  <app-table-personalization
    [disabled]="isFclOpen"
    [tableKey]="currentTableKey"
  ></app-table-personalization>
  @if (advancedSearchOpen) {
    <button
      fd-button
      fdType="transparent"
      (click)="onAdvancedSearchToggled(false)"
      title="Close Advanced Search"
    >
      <app-icon icon="times"></app-icon>
    </button>
  }
</ng-template>

@if (resourceContent.containerIsMoving) {
  <app-info-strip
    infoText="This resource group and its contents are currently being moved to a new location."
    moreDetails="View operation details"
    (moreInfoClick)="openOperationJson()"
  ></app-info-strip>
}

<app-resource-content
  #resourceContent
  [noDataMessage]="noDataMessage"
  [noDataFilteredMessage]="noDataFilteredMessage"
  (toggleFclMain)="toggleFcl($event)"
  [searchTerm]="searchTerm"
  [currentPath]="_currentPath"
  [currentType]="resourceType"
  [organizationName]="currentOrg"
  [fullPath]="_fullPath"
  [advancedSearchTerms]="advancedSearchTerms"
  [advancedSearchOpen]="advancedSearchOpen"
  [availableResourceTypes]="availableResourceTypes"
  [currentFilterViewName]="currentFilterViewName"
  (advancedSearchToggled)="onAdvancedSearchToggled($event)"
  (viewSaved)="onViewSaved($event)"
  (filtersChanged)="onFiltersChanged()"
  [systemResourcesByGroup]="systemResourcesByGroup"
  (publish)="onCreateServiceInstance($event)"
  (resourceContentIsMoving)="handleMoving($event)"
  (errorEvent)="error = $event"
></app-resource-content>
